<template>
  <div class="row main-content">
    <div class="col">
      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="mx-auto d-block center-block"
        >
      </div>

      <div v-else>
        <h1 class="page-title font-custom text-uppercase mt-3">
          {{ $t('title.beneficiaryservice.details') }}
        </h1>

        <div
          v-if="responseErr"
          class="alert alert-danger text-center border-0 shadow-sm rounded-0"
        >
          <strong>
            {{ $t('error.'+`${responseErr}`) }}
          </strong>
        </div>

        <div v-if="$store.state.beneficiaries.bsDetail">
          <div
            id="accordionDetail"
            class="card rounded-0 mb-4"
          >
            <div
              id="headingDetail"
              data-bs-toggle="collapse"
              href="#collapseDetail"
              aria-expanded="false"
              aria-controls="collapseDetail"
              class="card-header font-accent fw-bold"
            >
              {{ $t('label.account.details') }}
            </div>
            <div
              id="collapseDetail"
              aria-labelledby="headingDetail"
              data-bs-parent="#accordionDetail"
              class="card-body collapse"
            >
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.beneficiary') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.beneficiaries.bsDetail.beneficiaryServiceRef) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.selectedDistributorRef') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.beneficiaries.bsDetail.distributorRef) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.funder') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.beneficiaries.bsDetail.funderContractRef) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.product') }}
                </div>
                <div class="col">
                  <template v-if="hasPermission('product:read')">
                    <div
                      role="button"
                      class="clickable-div"
                      @click="showProduct($store.state.beneficiaries.bsDetail.productExternalReference)"
                    >
                      {{ $filters.nullFilter($store.state.beneficiaries.bsDetail.productExternalReference) }}
                    </div>
                  </template>
                  <template v-else>
                    {{ $filters.nullFilter($store.state.beneficiaries.bsDetail.productExternalReference) }}
                  </template>
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.beneficiaryStatus') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.beneficiaries.bsDetail.beneficiaryServiceStatus) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.selectedCreationDate') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.beneficiaries.bsDetail.creationDateIHM) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.selectedClosingDate') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.beneficiaries.bsDetail.closureDateIHM) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.beneficiaryServiceProfile') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.beneficiaries.bsDetail.profileRef) }}
                </div>
              </div>
            </div>
          </div>

          <div
            id="accordionCompte"
            class="card rounded-0 mb-4"
          >
            <div
              id="headingCompte"
              data-bs-toggle="collapse"
              href="#collapseCompte"
              aria-expanded="false"
              aria-controls="collapseCompte"
              class="card-header font-accent fw-bold"
            >
              {{ $t('label.account.account') }}
            </div>
            <div
              id="collapseCompte"
              aria-labelledby="headingCompte"
              data-bs-parent="#accordionCompte"
              class="card-body collapse"
            >
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.account') }}
                </div>
                <div class="col">
                  <strong>
                    <div
                      role="button"
                      class="clickable-div"
                      @click="showAccount($store.state.beneficiaries.bsDetail.accountDetailsPageContext)"
                    >
                      {{ $t('label.account.beneficiaryAccount') }}
                    </div>
                  </strong>
                </div>
              </div>
              <div
                v-if="!$store.state.beneficiaries.bsDetail.singleFunderAccount"
                class="row"
              >
                <div class="col-3 text-end">
                  {{ $t('label.account.balance') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.beneficiaries.bsDetail.accountBalance) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.account.openToBuy') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.beneficiaries.bsDetail.accountAvailable) }}
                </div>
              </div>
            </div>
          </div>

          <div v-if="$store.state.beneficiaries.bsDetail.cardAndOrderListIsNotNull">
            <div
              id="accordionCartes"
              class="card rounded-0 mb-4"
            >
              <div
                id="headingCartes"
                data-bs-toggle="collapse"
                href="#collapseCartes"
                aria-expanded="false"
                aria-controls="collapseCartes"
                class="card-header font-accent fw-bold"
              >
                {{ $t('label.account.cards') }}
              </div>
              <div
                id="collapseCartes"
                aria-labelledby="headingCartes"
                data-bs-parent="#accordionCartes"
                class="card-body collapse"
              >
                <div v-if="$store.state.beneficiaries.bsDetail.cards">
                  <div
                    v-for="opcCard in $store.state.beneficiaries.bsDetail.cards"
                    :key="opcCard.id"
                    class="border-top"
                  >
                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.cards.cardId') }}
                      </div>
                      <div class="col">
                        <strong>
                          <div
                            role="button"
                            class="clickable-div"
                            @click="showCard(opcCard)"
                          >
                            {{ opcCard.cardId }}
                          </div>
                        </strong>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.cards.cardStatus') }}
                      </div>
                      <div class="col">
                        {{ $filters.nullFilter(opcCard.cardStatus) }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.cards.panCard') }}
                      </div>
                      <div class="col">
                        {{ opcCard.panCard }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.cards.psnCard') }}
                      </div>
                      <div class="col">
                        {{ opcCard.psnCard }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.cards.expiryDate') }}
                      </div>
                      <div class="col">
                        {{ opcCard.expiryDate }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="accordionCommandes"
              class="card rounded-0 mb-4"
            >
              <div
                id="headingCommandes"
                data-bs-toggle="collapse"
                href="#collapseCommandes"
                aria-expanded="false"
                aria-controls="collapseCommandes"
                class="card-header font-accent fw-bold"
              >
                {{ $t('label.account.orders') }}
              </div>
              <div
                id="collapseCommandes"
                aria-labelledby="headingCommandes"
                data-bs-parent="#accordionCommandes"
                class="card-body collapse"
              >
                <div v-if="$store.state.beneficiaries.bsDetail.orders">
                  <div
                    v-for="opcOrder in $store.state.beneficiaries.bsDetail.orders"
                    :key="opcOrder.id"
                    class="border-top"
                  >
                    <div class="row">
                      <div class="col-2 text-end">
                        {{ opcOrder.orderType }}
                      </div>
                      <div class="col">
                        <strong>
                          <div
                            role="button"
                            class="clickable-div"
                            @click="showOrder(opcOrder)"
                          >
                            n° {{ opcOrder.orderId }}
                          </div>
                        </strong>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.orders.expeditionRef') }}
                      </div>
                      <div class="col">
                        {{ opcOrder.expeditionRef }}
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.orders.orderStatus') }}
                      </div>
                      <div class="col">
                        {{ opcOrder.orderStatus }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="$store.state.beneficiaries.bsDetail.notificationPrefs"
            id="accordion5"
            class="card rounded-0 mb-4"
          >
            <div
              id="heading5"
              data-bs-toggle="collapse"
              href="#collapse5"
              aria-expanded="false"
              aria-controls="collapse5"
              class="card-header font-accent fw-bold"
            >
              {{ $t('label.account.notificationData') }}
            </div>
            <div
              id="collapse5"
              aria-labelledby="heading5"
              data-bs-parent="#accordion5"
              class="card-body collapse"
            >
              <div>
                <div
                  v-for="currentNotificationPref in $store.state.beneficiaries.bsDetail.notificationPrefs"
                  :key="currentNotificationPref.id"
                  class="border-top"
                >
                  <div class="row">
                    <div class="col-2 text-end">
                      {{ currentNotificationPref.eltName }}
                    </div>
                    <div class="col">
                      {{ currentNotificationPref.eltValue }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <goTopButton />
  </div>
</template>

<script src="./BeneficiaryDetail.js"></script>

<style src="./BeneficiaryDetail.scss" scoped lang="scss"></style>
